import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useOrderValue, useTab } from '@/hooks/tab';
import { useCurrentOrderItem } from '@/hooks/reference';
import { Order } from '@/types/order';
import { Modal } from '@/types/modal';
import { Tab } from '@/types/hashes';
import Grid, { itemText, GridAction, itemLinkButton } from '@/components/molecules/section/Grid';
import Container from '@/components/molecules/section/Container';
import { transformDateString } from '@/utilities/datetime';
import ModalView from '@/components/modals/Modal';

const View: React.FC<{ order: Order }> = ({ order }) => {
  const { t } = useTranslation();

  const [tab, setTab] = useTab();

  const [, setInputValue] = useOrderValue();

  const [currentOrderItem] = useCurrentOrderItem();

  const [modal, setModal] = useState<Modal | null>(null);

  const actions: GridAction[] = [
    {
      kind: 'Button',
      label: t('order.invoice.invoice_pdf').toUpperCase(),
      onClick: () => setModal({ kind: 'OrderInvoice', isLitigation: false, order, onClose: () => setModal(null) }),
    },
    {
      kind: 'Button',
      label: t('order.invoice.invoice_litigation').toUpperCase(),
      onClick: () => setModal({ kind: 'OrderInvoice', isLitigation: true, order, onClose: () => setModal(null) }),
    },
  ];

  const items = [
    tab === Tab.ORDER && currentOrderItem === ''
      ? null
      : itemLinkButton(t('order.invoice.order_ref'), {
          kind: 'Button',
          label: order.orderId?.toString() || '-',
          disabled: !order.orderId,
          onClick: () => {
            if (order.orderId) {
              setInputValue(order.orderId.toString());
              setTab(Tab.ORDER);
            }
          },
        }),
    itemText(t('order.invoice.invoice_date'), transformDateString(order.invoiceDate, 'DD/MM/YYYY')),
    itemText(t('order.invoice.paid_amount'), order.total),
    itemText(t('order.invoice.authentication_fee'), order.authenticationFee),
    itemText(t('order.invoice.shipping_fee'), order.shippingFee),
    itemText(t('order.invoice.fx_markup'), order.markUpFee),
    itemText(t('order.invoice.duties'), order.dutyFee),
    itemText(t('order.invoice.sales_tax'), order.salesTax),
    itemText(t('order.invoice.buyerServiceFees'), order.buyerServiceFee),
    itemText(t('order.invoice.total_discount'), order.totalDiscount),
    itemText(t('order.invoice.promo_code'), order.promoCode),
  ];

  return (
    <>
      <Container
        title={t('order.invoice.title')}
        actions={actions}
        testId="invoice_info"
      >
        <Grid
          column={5}
          items={items.filter((i) => i != null)}
        />
      </Container>
      <ModalView modal={modal} />
    </>
  );
};

export default View;
